import React, { Component } from 'react';
import classNames from 'classnames'
import ArrowDown from '@material-ui/icons/ArrowBackIos'

import styles from './index.css';

export default class ArrowScroll extends Component {
  render() {
    return ( 
      <div className={classNames(styles['arrowDownWrapper'],this.props.className)}>
        <ArrowDown className={styles['arrowDown']}/>
      </div>
    );
  }
}
  



// WEBPACK FOOTER //
// ./src/blocks/ArrowScroll/index.js